module.exports = __webpack_public_path__ + "media/images/icons/place-0194197c47dc203b72d6bd9d9970db1a.svg";